export class EmployeeDTO{
  public id: number;
  public name: string;
  public identificationNo: string;
  public address: string;
  public contactNo1: string;
  public contactNo2: string;
  public email: string;
  public status: string;
  public employeeDesignation: string;
  public employeeDesignationCode: string;
  public user: string;
  public url: string;


  constructor(id: number, name: string, identificationNo: string, address: string, contactNo1: string, contactNo2: string, email: string, status: string, employeeDesignation: string,employeeDesignationCode: string, user: string, url: string) {
    this.id = id;
    this.name = name;
    this.identificationNo = identificationNo;
    this.address = address;
    this.contactNo1 = contactNo1;
    this.contactNo2 = contactNo2;
    this.email = email;
    this.status = status;
    this.employeeDesignation = employeeDesignation;
    this.employeeDesignationCode = employeeDesignationCode;
    this.user = user;
    this.url = url;
  }
}
